import { Component } from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import ReactModal from 'react-modal';
import BasicMessageModal from 'screens/modals/BasicMessageModal';
import ChooseConnectionModal from 'screens/modals/ChooseConnectionModal';
import ExportParkingHistoryModal from 'screens/modals/sessionExport/ExportParkingHistoryModal';
import SendMessageToSupportModal from 'screens/modals/SendMessageToSupportModal';
import SendFeedbackToSupportModal from 'screens/modals/SendFeedbackToSupportModal';
import InviteYourDriversModal from 'screens/modals/vehicles/InviteYourDriversModal';
import SomethingWentWrongModal from 'screens/modals/SomethingWentWrongModal';
import InfoModalParkingMode from 'screens/modals/vehicles/InfoModalParkingMode';
import ImportLicensePlatesSucceededModal from 'screens/modals/ImportLicensePlatesSucceededModal';
import ConfirmationDialogModal from 'screens/modals/ConfirmationDialogModal';
import DeleteVehicleModal from 'screens/modals/vehicles/DeleteVehicleModal';
import { ReduxState } from 'types';
import { ModalEnum } from 'myParkdUtils/enums';
import { authSlice } from 'features/auth/authSlice';
import ChangeParkingModeModal from 'screens/modals/vehicles/ChangeParkingModeModal';
import InfoModal from 'screens/modals/InfoModal';
import EditCompanyWorkingHoursModal from 'screens/modals/EditCompanyWorkingHoursModal';
import EditWorkingHoursLicensePlateModal from 'screens/modals/vehicles/EditWorkingHoursLicensePlateModal';
import ManageTableColumnsModal from 'screens/modals/ManageTableColumnsModal';
import EditSessionNoteModal from 'screens/modals/vehicles/EditSessionNoteModal';
import EditCostCenterModal from 'screens/modals/vehicles/EditCostCenterModal';
import EditUserModal from 'screens/modals/users/EditUserModal';
import DeleteUserModal from 'screens/modals/users/DeleteUserModal';


type Props = {
    modalWindow: {
        modalName: ModalEnum,
        modalData: any
    },
    updateModal: Function,
    logout: Function
}

class ModalWindows extends Component<Props> {

    // todo: replace with GTM
    /* 
    componentDidUpdate() {
        let modalName = this.props?.modalWindow.modalName;
        if (modalName !== null) {
            ReactGA.send({ hitType: "pageview", modalName });
        } else {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
        }
    }
    */

    closeModal = () => {
        this.props.updateModal(null);
    };

    updateModal = (modalName: string, modalData: Object) => {
        this.props.updateModal(modalName, modalData);
    };

    render() {
        let modalIsOpen = false;
        if (this.props.modalWindow.modalName != null) {
            modalIsOpen = true;
        }

        return (
            <ReactModal
                appElement={document.getElementById('root')}
                isOpen={modalIsOpen}
                onRequestClose={this.closeModal}
                className={{
                    base: 'modal-window',
                    afterOpen: '',
                    beforeClose: '',
                }}
                overlayClassName={{
                    base: 'black-matte',
                    afterOpen: '',
                    beforeClose: '',
                }}
            >
                {(() => {
                    switch (this.props.modalWindow.modalName) {
                        case ModalEnum.BASIC_MESSAGE_MODAL:
                            return (
                                <BasicMessageModal
                                    modalContent={this.props.modalWindow.modalData.modalContent}
                                    closeModal={this.closeModal}
                                    logout={this.props.logout}
                                />
                            );

                        case ModalEnum.SEND_MESSAGE_TO_SUPPORT:
                            return (
                                <SendMessageToSupportModal
                                    modalContent={this.props.modalWindow.modalData.modalContent}
                                    closeModal={this.closeModal}
                                />
                            );

                        case ModalEnum.SEND_FEEDBACK_TO_SUPPORT:
                            return (
                                <SendFeedbackToSupportModal
                                    starRatingData={this.props.modalWindow.modalData}
                                    closeModal={this.closeModal}
                                />
                            );

                        case ModalEnum.CONFIRMATION_DIALOG:
                            return (
                                <ConfirmationDialogModal
                                    modalTitle={this.props.modalWindow.modalData.modalTitle}
                                    modalText={this.props.modalWindow.modalData.modalText}
                                    confirmButtonText={this.props.modalWindow.modalData.confirmButtonText}
                                    confirmButtonClass={this.props.modalWindow.modalData.confirmButtonClass}
                                    loadingMessage={this.props.modalWindow.modalData.loadingMessage}
                                    successMessage={this.props.modalWindow.modalData.successMessage}
                                    actionOnConfirm={this.props.modalWindow.modalData.actionOnConfirm}
                                    actionOnCompleted={this.props.modalWindow.modalData.actionOnCompleted}
                                    actionOnError={this.props.modalWindow.modalData.actionOnError}
                                />
                            );

                        case ModalEnum.CHANGE_PARKING_MODE:
                            return (
                                <ChangeParkingModeModal
                                    modalData={this.props.modalWindow.modalData}
                                />
                            )

                        case ModalEnum.EXPORT_HISTORY:
                            return (
                                <ExportParkingHistoryModal
                                    modalData={this.props.modalWindow.modalData}
                                />
                            );

                        case ModalEnum.INVITE_YOUR_DRIVERS:
                            return <InviteYourDriversModal />;

                        case ModalEnum.CHOOSE_CONNECTION:
                            return <ChooseConnectionModal trackAndTrace={this.props.modalWindow.modalData} closeModal={this.closeModal} />;

                        case ModalEnum.SOMETHING_WENT_WRONG:
                            return <SomethingWentWrongModal error={this.props.modalWindow.modalData} closeModal={this.closeModal} />;

                        case ModalEnum.INFO_MODAL:
                            return <InfoModal
                                modalTitleFormattedMessageId={this.props.modalWindow.modalData.modalTitleFormattedMessageId}
                                modalTextFormattedMessageId={this.props.modalWindow.modalData.modalTextFormattedMessageId}
                                closeModal={this.closeModal}
                            />;

                        case ModalEnum.INFO_MODAL_PARKING_MODE:
                            return <InfoModalParkingMode closeModal={this.closeModal} />;

                        case ModalEnum.DELETE_VEHICLE:
                            return <DeleteVehicleModal vehicle={this.props.modalWindow.modalData} closeModal={this.closeModal} />;

                        case ModalEnum.DELETE_USER:
                            return <DeleteUserModal modalData={this.props.modalWindow.modalData} />;

                        case ModalEnum.IMPORT_LICENSE_PLATES_SUCCEEDED:
                            return (
                                <ImportLicensePlatesSucceededModal
                                    invalidImportRequests={this.props.modalWindow.modalData.invalidImportRequests}
                                    validImportRequests={this.props.modalWindow.modalData.validImportRequests}
                                    closeModal={this.closeModal}
                                />
                            );

                        case ModalEnum.EDIT_WORKING_HOURS_COMPANY:
                            return <EditCompanyWorkingHoursModal />

                        case ModalEnum.EDIT_WORKING_HOURS_LICENSEPLATE:
                            return <EditWorkingHoursLicensePlateModal vehicle={this.props.modalWindow.modalData} />

                        case ModalEnum.EDIT_SESSION_NOTE:
                            return <EditSessionNoteModal session={this.props.modalWindow.modalData} />

                        case ModalEnum.EDIT_COST_CENTER:
                            return <EditCostCenterModal vehicle={this.props.modalWindow.modalData} />

                        case ModalEnum.EDIT_USER:
                            return <EditUserModal modalData={this.props.modalWindow.modalData} />

                        case ModalEnum.MANAGE_TABLE_COLUMNS:
                            return <ManageTableColumnsModal modalData={this.props.modalWindow.modalData} />

                        default:
                            return '';
                    }
                })()}

                <a href="# " className="close-modal" onClick={this.closeModal}>
                    &times;
                </a>
            </ReactModal>
        );
    }
}


function mapStateToProps(state: ReduxState) {
    return {
        modalWindow: state.modalWindow,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            updateModal: modalWindowActions.updateModalWindow,
            logout: authSlice.actions.logout
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalWindows);